export default __webpack_public_path__ + "static/studyoffice-study2-add06d94b1635a732c37c05828e7cf99.jpg";